import { render, staticRenderFns } from "./TenantAddDialog.vue?vue&type=template&id=736d0b28&scoped=true&"
import script from "./TenantAddDialog.vue?vue&type=script&lang=js&"
export * from "./TenantAddDialog.vue?vue&type=script&lang=js&"
import style0 from "./TenantAddDialog.vue?vue&type=style&index=0&id=736d0b28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736d0b28",
  null
  
)

export default component.exports